import React from 'react';
import Q3Conclusion from './Q3Conclusion';
import Q3Header from './Q3Header';
import Q3Row1 from './Q3Row1';
import Q3Row2 from './Q3Row2';
import Q3Row3 from './Q3Row3';

function StoryQ3() {
  return (
    <>
      <Q3Header />
      <Q3Row1 />
      <Q3Row2 />
      <div className="pagebreak80" />
      <Q3Row3 />
      <Q3Conclusion />
    </>
  );
}

export default StoryQ3;
